/**
 * Coerce a stored or API avatar value into a usable URL, or `''` when missing.
 * Guards against `null`/`undefined`, whitespace, and the stringified `"null"` /
 * `"undefined"` that `localStorage.setItem` can leave behind when a caller
 * persisted a missing image.
 */
export function normalizeAvatarUrl(url: string | null | undefined): string {
    const value = (url ?? '').trim();
    if (!value || value === 'null' || value === 'undefined') {
        return '';
    }
    return value;
}
